<template>
  <div>
    <el-upload
      ref="upload"
      :class="{ disabled: disabled }"
      :action="FILE_UPLOAD_HOST"
      :data="REQData"
      :name="file_name"
      :accept="accept"
      :multiple="multiple"
      :show-file-list="false"
      :on-error="uploadError"
      :on-success="uploadSuccess"
      :before-upload="beforeAvatarUpload"
      :disabled="disabled"
    >
      <template v-if="!disabled">
        <slot name="upload"></slot>
      </template>
    </el-upload>
  </div>
</template>

<script>
import { baseURL, fileUpUrl } from "@/config";
export default {
  name: "UploadFile",
  components: {},
  data() {
    return {
      FILE_PATH: baseURL,
      FILE_UPLOAD_HOST: fileUpUrl,
      REQData: {},
      files: [],
      loading: false,
    };
  },
  props: {
    url: {
      // 上传地址
      type: String,
      default: "",
    },
    name: {
      // 多个上传时 用来区分
      type: String,
      default: "",
    },
    file_name: {
      // 文件上传字段名称
      type: String,
      default: "file",
    },
    params: {
      // 接口的参数，
      type: [String, Object],
      default: "",
    },
    disabled: {
      // 是否可用
      type: Boolean,
      default: false,
    },
    auth: {
      //是否验证
      type: Boolean,
      default: false,
    },
    multiple: {
      //多文件上传
      type: Boolean,
      default: false,
    },
    accept: {
      // 文件类型
      type: String,
      default: "*",
    },
    size: {
      //文件大小
      type: Number,
      default: 20,
    },
    image_size: {
      //图片大小 宽/高
      type: Number,
      default: 0,
    },
    image_aspect: {
      //图片比例
      type: String,
      default: "",
    },
  },
  created() {},
  methods: {
    //  上传判断
    beforeAvatarUpload(file) {
      let _this = this;
      const isLt2M = file.size / 1024 / 1024 < _this.size;
      if (_this.image_size > 0) {
        return new Promise((resolve, reject) => {
          let image = new Image();
          // 设置图片加载完成后的回调函数
          image.onload = function () {
            // 打印图片的宽度和高度
            const isNotSize = image.width / image.height === _this.image_size;
            if (!isNotSize)
              this.$message.error(`请上传${_this.image_aspect}像素的图片`);
            if (!isLt2M)
              this.$message.error(`上传文件大小不能超过 ${_this.size}MB!`);
            if (isLt2M && isNotSize) {
              _this.uping = _this.$loading({
                lock: true,
                text: "正在上传...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.2)",
              });
              resolve();
            } else {
              reject();
            }
          };
          image.onerror = function () {
            reject();
          };
          image.src = URL.createObjectURL(file);
        });
      } else {
        if (!isLt2M) {
          this.$message.error(`上传文件大小不能超过 ${_this.size}MB!`);
        }
        if (isLt2M) {
          this.uping = this.$loading({
            lock: true,
            text: "文件正在上传，请稍等...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.2)",
          });
        }
        return isLt2M;
      }
    },
    //  上传成功
    uploadSuccess(res, file) {
      this.uping.close();

      // 如果包含https:// 则说明是完整地址
      if (res.data.file_path.indexOf("http") != -1) {
        res.data.file_path = res.data.file_path;
      } else {
        res.data.file_path = this.FILE_PATH + res.data.file_path;
      }

      this.$emit("uploadFile", {
        name: this.name,
        data: this.params,
        file: {
          name: file.name,
          url: `${res.data.file_path}`,
        },
      });
    },
    //  上传失败
    uploadError() {
      this.uping.close();
      this.$message.error(`上传失败，请重试`);
    },
  },
  watch: {},
};
</script>

<style></style>
